const MEDIA_HEADERS = ['IMAGE', 'VIDEO', 'DOCUMENT'];
const MAX_BUTTONS = 10;

export const countVariables = text =>
  (text?.match(/\{\{\d+\}\}/g) || []).length;

// Devolve a mensagem de erro, ou null quando o formulário está pronto pra
// envio. Validar aqui poupa um POST que criaria template errado — e template
// criado não sai pela API, só pelo WhatsApp Manager.
export const validate = form => {
  if (!form.name?.trim()) return 'informe o nome do template';
  if (!form.bodyText?.trim()) return 'informe o corpo da mensagem';

  const variables = countVariables(form.bodyText);
  const examples = (form.bodyExamples || []).filter(e => `${e}`.trim());
  if (variables > 0 && examples.length !== variables) {
    return 'preencha um exemplo para cada variável do corpo';
  }

  if (MEDIA_HEADERS.includes(form.headerType) && !form.headerFile) {
    return 'anexe um arquivo de exemplo para o cabeçalho de mídia';
  }

  if ((form.buttons || []).length > MAX_BUTTONS) {
    return `no máximo ${MAX_BUTTONS} botões`;
  }

  return null;
};

export const buildFormData = form => {
  const data = new FormData();
  data.append('name', form.name);
  data.append('language', form.language || 'pt_BR');
  data.append('category', form.category || 'MARKETING');
  data.append('body_text', form.bodyText);

  (form.bodyExamples || []).forEach(example =>
    data.append('body_examples[]', example)
  );

  if (form.headerType && form.headerType !== 'NONE') {
    data.append('header_type', form.headerType);
    if (form.headerType === 'TEXT') data.append('header_text', form.headerText);
    if (form.headerFile) data.append('header_file', form.headerFile);
  }

  if (form.footerText) data.append('footer_text', form.footerText);

  (form.buttons || []).forEach(button => {
    Object.entries(button).forEach(([key, value]) => {
      if (value) data.append(`buttons[][${key}]`, value);
    });
  });

  return data;
};
